// @flow
import React from 'react';
import { Strong } from '@finect/tabular-core/Strong';
import { EntryEditor } from '@finect/tabular-draft-editor';
import type { UserType } from '../../../types';
import { CommentDetail, CommentAuthor } from './CommentDetail';

type Props = {
  inputRef: Function,
  user: UserType,
  defaultValue: string,
  handleReturn: Function,
  focusEditor: Function
};

type State = {
  selectedProducts: Array<Object>
};

export class PostComment extends React.Component<Props, State> {
  state = {
    selectedProducts: []
  };

  addProduct = (newProduct: Object) => {
    const newProducts = [...this.state.selectedProducts];
    const pos = newProducts.findIndex((product) => {
      const id = (newProduct.entity && newProduct.entity.id) || newProduct.id;
      return product.entity.id === id;
    });

    if (pos === -1) {
      newProducts.push(newProduct);
      this.setState({ selectedProducts: newProducts });
    }
  };

  removeProduct = (products: Array<Object>) => {
    const { selectedProducts } = this.state;

    // Nothing to delete
    if (!selectedProducts.length) return;
    if (products.length === selectedProducts.length) return;

    // All previous products have been removed
    if (!products.length) {
      this.setState({ selectedProducts: [] });
    }

    // Remove deleted products
    const newProducts = selectedProducts.filter(product => products.includes(product.entity.id));
    this.setState({ selectedProducts: newProducts });
  };

  handleReturn = (cb: Function) => {
    this.props.handleReturn(this.state.selectedProducts, cb);
  };

  render() {
    const { inputRef, user, defaultValue, focusEditor } = this.props;

    return (
      <CommentDetail isAuthor>
        <CommentAuthor>
          <Strong>{user.username}</Strong>
        </CommentAuthor>
        <div>
          <EntryEditor
            minimal
            inputRef={inputRef}
            placeholder={defaultValue}
            focusEditor={focusEditor}
            handleReturn={this.handleReturn}
            handleAddProduct={this.addProduct}
            handleRemoveProduct={this.removeProduct}
            decorators={['mentions', 'products', 'inlink', 'limit']}
            limit={{ chars: 600 }}
          />
        </div>
      </CommentDetail>
    );
  }
}
